module.exports = "/fonts/element-icons.ttf?24ae61b1eb720924f162c1659b3fc695";